const authenticationPolicyEn = {
  aal: {
    aal1: {
      label: 'Single factor'
    },
    aal2: {
      label: 'Multi-factor (MFA)'
    }
  },
  action: {
    addCondition: 'Add condition',
    addConditionGroup: 'Add nested group',
    addRequirement: 'Add requirement',
    addRule: 'Add rule',
    removeCondition: 'Remove condition',
    removeRequirement: 'Remove requirement',
    removeRule: 'Remove rule'
  },
  condition: {
    aalLevelLabel: 'Minimum authentication strength',
    deviceGroupIdsLabel: 'Device groups',
    deviceGroupLoadError: 'Could not load device groups. Please reload.',
    deviceGroupLoading: 'Loading device groups…',
    deviceGroupPlaceholder: 'Select at least one device group',
    identifierLabel: 'Identifier type',
    methodRefsLabel: 'Login methods (matches any)',
    methodRefsLoadError: 'Could not load SSO connections. Login methods for this condition cannot be changed. Please reload.',
    methodRefsLoading: 'Loading SSO connections…',
    methodRefsPlaceholder: 'Select at least one login method',
    networkIdsLabel: 'Networks',
    networkIpUnset: 'IP not set',
    networkIpUnsetWarning: 'Some selected networks have no IP registered. They will not match during evaluation. Register an IP in the network ledger.',
    networkLoadError: 'Could not load networks. Please reload.',
    networkLoading: 'Loading networks…',
    networkPlaceholder: 'Select at least one network'
  },
  conditionKind: {
    DEVICE_IN_GROUPS: {
      description: 'The device in use belongs to one of the selected groups.',
      label: 'Device belongs to a group'
    },
    LOGIN_IDENTIFIER: {
      description: 'Which kind of address was used to sign in — work or personal.',
      label: 'Login identifier type'
    },
    NETWORK_IN: {
      description: 'The source IP falls within one of the selected networks.',
      label: 'Source network'
    },
    SESSION_AAL_AT_LEAST: {
      description: 'The session meets at least the selected authentication strength.',
      label: 'Authentication strength is at least'
    },
    SESSION_IS_FEDERATED: {
      description: 'The session was established through SSO.',
      label: 'Session is an SSO session'
    },
    USED_LOGIN_METHOD: {
      description: 'The login method used matches any of the selected ones.',
      label: 'Login method used'
    }
  },
  decision: {
    ALLOW: {
      description: 'Allow sign-in. You can add further requirements below.',
      label: 'Allow'
    },
    DENY: {
      description: 'Block sign-in. No additional requirements can be set for a denial.',
      label: 'Deny'
    }
  },
  enforceFrom: {
    datePlaceholder: 'Select a date',
    description: 'This rule does not apply until the date and time you set.',
    label: 'Set an effective date'
  },
  join: {
    AND: 'Match all conditions (AND)',
    OR: 'Match any condition (OR)',
    label: 'How to combine conditions'
  },
  loginIdentifier: {
    personal: 'Personal email',
    work: 'Work email'
  },
  loginMethod: {
    password: 'Password'
  },
  membershipType: {
    INDIVIDUAL: 'Member',
    OPERATOR: 'Staff'
  },
  outcome: {
    allowedLoginMethods: {
      description: 'Restrict which login methods are accepted. At least one must be selected.',
      label: 'Allowed login methods',
      loadError: 'Could not load SSO connections, so only Password is listed. Reload before restricting login methods — saving now could lock out SSO users.',
      loading: 'Loading SSO connections\u2026'
    },
    authenticationRequirement: {
      description: 'Passing any one of these is enough. Users who do not meet them are prompted to step up (MFA).',
      empty: 'No additional requirements.',
      label: 'Additional authentication requirements'
    },
    denyDiscardsObligations: 'Saving this rule as Deny discards its additional requirements, allowed login methods, and personal email setting.',
    personalEmailMode: {
      label: 'Personal email sign-in'
    },
    title: 'Action'
  },
  personalEmailMode: {
    ALWAYS_ALLOWED: 'Always allowed',
    DISALLOWED: 'Not allowed',
    UNSET: 'Not specified in this rule',
    UNTIL_WORK_EMAIL_SET: 'Allowed until a work email is set'
  },
  requirement: {
    AAL_AT_LEAST: 'Authentication strength is at least',
    FEDERATED_SESSION: 'Must be an SSO session'
  },
  rule: {
    catchAllBadge: 'Fallback',
    catchAllDescription: 'Applied when none of the rules above match. Conditions cannot be added.',
    catchAllTitle: 'Fallback rule',
    conditionsTitle: 'Conditions',
    emptyConditions: 'No conditions yet. Add at least one.',
    groupTitle: 'Condition group',
    ifBadge: 'IF',
    ifMatched: 'If these conditions match',
    nameLabel: 'Display name',
    namePlaceholder: 'e.g. Network-based access control',
    terminalBadge: '{{decision}} (terminal)',
    untitled: 'Untitled rule'
  },
  status: {
    DRAFT: {
      label: 'Draft'
    },
    ENFORCED: {
      label: 'Enforced'
    },
    REPORT_ONLY: {
      label: 'Report only'
    }
  },
  validation: {
    ALLOWED_LOGIN_METHODS_REQUIRED: 'Select at least one allowed login method. An empty list would deny every method.',
    APPLICATION_SCOPE_REQUIRED: 'Select at least one application, or turn off the scope restriction.',
    ASSIGNMENT_REQUIRED: 'Select at least one target.',
    CONDITION_REQUIRES_VALUE: 'Select at least one value for this condition.',
    DEFAULT_POLICY_FINAL_RULE_MUST_ALLOW: 'The fallback rule of the default policy cannot deny access, because it would lock everyone out.',
    ENFORCE_FROM_INCOMPLETE: 'Enter both a date and a time for the effective date.',
    FINAL_RULE_MUST_NOT_HAVE_CONDITIONS: 'The fallback rule cannot have conditions.',
    GROUP_REQUIRES_CONDITION: 'A condition group needs at least one condition.',
    NAME_REQUIRED: 'Enter a name.',
    POLICY_REQUIRED: 'Select an authentication policy.',
    RULE_REQUIRES_CONDITION: 'Every rule except the fallback needs at least one condition, otherwise later rules are never evaluated.'
  }
};
export default authenticationPolicyEn;